import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';
import httpDriver from 'app/utils/httpDriver';
// import { deleteArticle } from 'news/Requests';
import { apiRoutes } from 'users/utils/apiRoutes';
import { apiRoutes as newsApiRoutes } from 'news/utils/apiRoutes';
import { apiRoutes as hashtagsApiRoutes } from 'hashtags/utils/apiRoutes';
import { apiRoutes as postsApiRoutes } from 'posts/utils/apiRoutes';
import { apiRoutes as reportsApiRoutes } from 'reports/utils/apiRoutes';
import { apiRoutes as tweetsApiRoutes } from 'tweets/utils/apiRoutes';
import { apiRoutes as adminApiRoutes } from 'admin/utils/apiRoutes';
import { TMutation, TQuery } from './types';
import { removeObjectOfIDs } from 'app/utils/helpers';
const URI_PREFIX = 'settings';

export const loadTableData = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(`${body.moduleName}`, body.data);
  return data;
};
export const getTableCellItems = async ({ queryKey }: TQuery): Promise<any> => {
  const QData = queryKey[1];
  const { data } = await httpDriver.post(`${QData.moduleName}`, QData.body);
  return data.payload.records;
};

export const bulkAction = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    `${body.moduleName}${checkIsStoryBookPath()}${body.action}`,
    {
      ids: body.ids || [],
      ...body?.bulkFilter,
    },
  );
  return data;
};

export const deleteBulkAction = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.delete(
    body?.activeTab === 'ungrabbed_articles'
      ? newsApiRoutes().deleteArticle
      : `${body.moduleName}${checkIsStoryBookPath()}${body.action}`,
    {
      data: {
        ids: body.ids || [],
        ...body?.bulkFilter,
      },
    },
  );
  return data;
};
export const fastReportBulkAction = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(reportsApiRoutes.fastReport, {
    item_ids: body.item_ids || [],
    template_id: body.template_id,
    report_name: body.report_name,
    ...body?.bulkFilter,
    ...body,
  });
  return data;
};

export const regrabBulkAction = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    body?.module === 'tweets'
      ? tweetsApiRoutes?.regrabTweet
      : body?.module === 'posts'
        ? postsApiRoutes.instagramRegrabPosts
        : body?.module === 'tiktok_posts'
          ? postsApiRoutes.tiktokRegrabPosts
          : body?.module === 'linkedin_posts'
            ? postsApiRoutes.linkedinRegrabPosts
            : body?.module === 'tiktok_posts_trending'
              ? postsApiRoutes.tiktokRegrabPosts
              : body?.module === 'twitter_posts'
                ? postsApiRoutes.regrabTweet
                : body?.module === 'youtube_posts' || body?.module === 'trending_youtube'
                ? postsApiRoutes.regrabVideo
                : body?.module === 'hashtags'
                  ? hashtagsApiRoutes().regrabHashtag
                  : body?.module === 'news'
                    ? newsApiRoutes().regrabArticle
                    : newsApiRoutes().regrabUnGrabbedArticle,
    body?.module === 'hashtags'
      ? { hashtag_ids: body.id || [] }
      : { ids: body.id || [] },
  );
  return data;
};

export const syncBulkAction = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(adminApiRoutes.adminSyncAction, {
    ids: body.id || [],
  });
  return data;
};

export const checkBulkAction = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(adminApiRoutes.adminCheckAction, {
    headless_sources_ids: body.id || [],
  });
  return data;
};

export const partialSyncBulkAction = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    adminApiRoutes.adminPartialSyncAction,
    { ids: body.id || [] },
  );
  return data;
};

export const loadPermissionGroup = async (): Promise<any> => {
  const { data } = await httpDriver.post('users/permission-groups/names');
  return data?.payload?.records?.map((option: any) => ({
    label: option.name,
    value: option.id,
  }));
};

export const loadCountriesNationality = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    `${URI_PREFIX}${checkIsStoryBookPath()}${queryKey[1]?.slug || 'countries'}`,
    queryKey[1]?.body || { status: 'ACTIVE' },
  );

  return data.payload?.records.map((country: any) => ({
    label: country.name,
    value: country.id,
    default: country.is_selected,
  }));
};
export const loadCountriesFullData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    `${URI_PREFIX}${checkIsStoryBookPath()}${queryKey[1]?.slug || 'countries'}`,
    queryKey[1]?.body || { status: 'ACTIVE' },
  );

  return data.payload?.records;
};

export const loadAllCountries = async (): Promise<any> => {
  const { data } = await httpDriver.post(
    `${URI_PREFIX}${checkIsStoryBookPath()}countries/all`,
  );
  const newData = data.payload?.records?.map((item: any) => ({
    label: item?.name,
    value: item?.id,
  }));
  return newData;
};

export const loadPlatforms = async (): Promise<any> => {
  const { data } = await httpDriver.get(
    `${URI_PREFIX}${checkIsStoryBookPath()}platforms`,
  );
  return {
    platforms: data.payload?.records,
    platformsOptions: data.payload?.records.map((platform: any) => ({
      label: platform.name,
      value: platform.id,
    })),
  };
};

export const loadBaseLineChartData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1]?.slug, queryKey[1]?.body);
  return data.payload?.records;
};

export const loadBasicColumnChart = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1]?.slug, queryKey[1]?.body);
  return data.payload?.records;
};

export const loadDataLabelChartData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1]?.slug, queryKey[1]?.body);
  return data.payload?.records;
};

export const loadDonutChartData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1]?.slug, queryKey[1]?.body);
  return {
    series: data?.payload?.records?.series,
    labels: data?.payload?.records?.labels,
  };
};

export const loadPieChartData = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1]?.slug, queryKey[1]?.body);
  return {
    series: data?.payload?.records?.series,
    labels: data?.payload?.records?.labels,
  };
};

export const handleAutocompleteField = async (
  body: TMutation,
): Promise<any> => {
  const { data } = await httpDriver.post(
    `${body.moduleName}${checkIsStoryBookPath()}auto-complete`,
    removeObjectOfIDs(body.data),
  );
  return data;
};

export const loadFrequentData = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1]?.slug, {
    ...queryKey[1].filters,
  });
  return data?.payload?.records;
};

export const barLatestFiveHour = async ({
  slug,
  body,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(slug, body);
  return data?.payload?.records;
};

export const barLatestFiveHourQuery = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { slug, body } = queryKey[1];
  const { data } = await httpDriver.post(slug, body);
  return data?.payload?.records;
};
export const getAchievments = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.achievements, queryKey[1]);
  return data?.payload?.records;
};

export const getLogsData = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    `${queryKey[2]}/${apiRoutes.logs}`,
    queryKey[1],
  );
  return data?.payload?.records;
};

export const loadSecondaryTableData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { slug, body } = queryKey[1];

  const { data } = await httpDriver.post(slug, body);
  return data?.payload?.records;
};

export const loadHashtagCountriesMap = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { slug, body } = queryKey[1];

  const { data } = await httpDriver.post(slug, body);
  return data?.payload?.records?.hashtags
    ? data?.payload?.records?.hashtags
    : data?.payload?.records
      ? data?.payload?.records
      : data?.payload || [];
};
export const loadNewCountriesIDMap = async ({
  slug,
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(slug, body);
  return data?.payload?.records;
};

export const addNewCategory = async ({
  slug,
  body,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(slug, body);
  return data?.payload?.records;
};

export const editCategory = async ({
  slug,
  body,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.put(slug, body);
  return data?.payload?.records;
};

export const getCategoryData = async ({
  slug,
  id,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(slug, { category_id: +id });
  return data?.payload?.records;
};

export const getRecentMedia = async ({ queryKey }: TQuery): Promise<any> => {
  const { slug, body } = queryKey[1];

  const { data } = await httpDriver.post(slug, body);
  return data?.payload?.records;
};

export const loadCompareCardData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { slug, body } = queryKey[1];

  const { data } = await httpDriver.post(slug, body);
  return {
    firstPercentage: data?.payload?.records?.male,
    secondPercentage: data?.payload?.records?.female,
  };
};

export const getTweetColumnData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { slug, body, category } = queryKey[1];
  const { data } = await httpDriver.post(slug, {
    ...body,
    category: category?.toUpperCase(),
  });
  return data;
};

export const getMapGraph = async ({ queryKey }: TQuery): Promise<any> => {
  const { slugName, body } = queryKey[1];
  const { data } = await httpDriver.post(slugName, body);
  return {
    links: data?.payload?.links,
    nodes: data?.payload?.nodes.map((item: any) => ({
      ...item,
      title: item.name,
      name: undefined,
    })),
    parent_ids: data?.payload?.parent_ids,
    require_nodes: data?.payload?.nodes,
  };
};

export const getMapGraphTree = async ({ queryKey }: TQuery): Promise<any> => {
  const { slugName, body } = queryKey[1];
  const { data } = await httpDriver.post(slugName, body);
  return data?.payload?.tree;
};
